import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FileService } from 'src/app/services/file/file.service';

@Component({
  selector: 'app-file-edit',
  imports: [FormsModule],
  templateUrl: './file-edit.component.html',
  styleUrl: './file-edit.component.css'
})
export class FileEditComponent {
  @Input() file: any;
  @Output() updated = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  newName = '';

  constructor(private fileService:  FileService){

  }

  ngOnInit() {
    this.newName = this.file.name.split('.')[0];
  }

  rename() {
    this.fileService.rename({
      old_path: this.file.path,
      new_name: this.newName
    }).subscribe(() => {
      this.updated.emit();
      this.close();
    });
  }

  close() {
    this.closed.emit();
  }
}
